import React, {useState} from 'react';
import {createPortal} from 'react-dom';
import Calendar from './Calendar.js';

const FormDate = React.forwardRef(({readOnly = false, label, value, setValue, error, placeholder = '', maxLength, iconPosTop = '50%'}, ref) => {
	const [showCal, setShowCal] = useState(false);

	if (placeholder === '') {
		placeholder = label;
	}

	if (!maxLength) {
		maxLength = 100;
	}

	const showMeta = label !== '' || error !== '';
	const iconStyle = iconPosTop === '50%' ? {top: '50%', transform: 'translateY(-50%)'} : {top: iconPosTop};

	const showCalendar = () => {
		setShowCal(true);
	};

	const closeCal = () => {
		setShowCal(false);
	};

	const returnValue = (val) => {
		setValue(val);
	};

	const iconClick = () => {
		if (readOnly) {
			showCalendar();
		}
	};

	return (
		<>
			<div className={`input-div input-div--with-icon${error !== '' ? ' has-error' : ''}`}>
				{showMeta ? (
					<div className="input-meta">
						<div className="input-meta-left">
							{label !== '' ? <div className="input-label">{label}</div> : ''}
						</div>
						{error !== '' ? <div className="input-error">{error}</div> : ''}
					</div>
				) : ''}
				<div className="input-control input-control--with-icon">
					<input className={`input-text ${readOnly ? 'cr_p' : ''}`} type="text" maxLength={maxLength} readOnly={readOnly} placeholder={placeholder} ref={ref} value={value} onChange={(e) => setValue(e.target.value)} onClick={() => iconClick()} />
					<span className="input-text-date-cal-icon" style={iconStyle} onClick={() => showCalendar()}></span>
				</div>
			</div>

			{typeof document !== 'undefined'
				? createPortal(<Calendar show={showCal} close={closeCal} defaultValue={value} returnValue={returnValue} />, document.body)
				: null}
		</>
	);
});

export default FormDate;
